module.exports = __webpack_public_path__ + "img/hover-xhs.b221e25a.png";